function getStyle() {
    const { width, height } = Q3.container.getBoundingClientRect();

    return Object.freeze({ width, height });
}

window.getStyle = getStyle;

export default getStyle;
export { getStyle };